(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-force-get-wager.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-force-get-wager.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const tipsenApi = svs.components.tipsen.store.tipsenApi;
const _svs$components$tipse = svs.components.tipsen.hooksWager,
  useGetCurrentWagerProductInfo = _svs$components$tipse.useGetCurrentWagerProductInfo,
  useGetDrawState = _svs$components$tipse.useGetDrawState;
const usePrevious = svs.components.lbUtils.usePrevious.usePrevious;
const drawStateEnums = svs.components.sport.tipsenShared.drawStateEnums;
const _React = React,
  useEffect = _React.useEffect;
const MAX_DELAY = 10000;
const MIN_DELAY = 7000;
const useForceGetWager = _ref => {
  let wagerId = _ref.wagerId;
  let timeout;
  const _useGetCurrentWagerPr = useGetCurrentWagerProductInfo({
      wagerId
    }),
    productId = _useGetCurrentWagerPr.productId,
    drawNumber = _useGetCurrentWagerPr.drawNumber;
  const drawState = useGetDrawState(productId, drawNumber);
  const previousDrawState = usePrevious(drawState);
  const _tipsenApi$useInvalid = tipsenApi.useInvalidatePlayerWagerTagMutation(),
    _tipsenApi$useInvalid2 = _slicedToArray(_tipsenApi$useInvalid, 1),
    invalidatePlayerWager = _tipsenApi$useInvalid2[0];
  useEffect(() => {
    if (drawState === drawStateEnums.FINALIZED && previousDrawState !== drawStateEnums.FINALIZED) {
      timeout = setTimeout(() => {
        invalidatePlayerWager({
          wagerId
        });
      }, Math.round(Math.random() * (MAX_DELAY - MIN_DELAY + 1) + MIN_DELAY));
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    };
  }, [drawState]);
};
setGlobal('svs.components.tipsen.hooksWager.useForceGetWager', useForceGetWager);

 })(window);